import { Component, Input, OnInit } from "@angular/core";
import {
  IMediaProxy,
  IRouterProxy,
  IToasterProxy,
  JobSettingsViewModel,
} from "./job-settings.view-model";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { MediaInfo } from "../../../../domain/media";
import { MediaRepository } from "../../../../domain/media-repository";

@Component({
  selector: "evrideo-job-settings",
  templateUrl: "./job-settings.component.html",
  styleUrls: ["./job-settings.component.scss"],
})
export class JobSettingsComponent implements OnInit {
  @Input()
  vm: JobSettingsViewModel;

  ngOnInit() {}
}
